<template>
  <b-card>
    <FormBuilder
      label="Kategori Induk"
      update
      :data="$store.state.parentCategory.detailData"
      :fields="fields"
      :loading-detail="$store.state.parentCategory.loadingDetail"
      :loading-submit="$store.state.parentCategory.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/parent-category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('parentCategory/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('parentCategory/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('parentCategory/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
